import Resource from "../base/resource";

class InformationTag extends Resource {
    name;
    defaultState;

    constructor(props) {
        super(props);
        this.name = props.name;

        this.defaultState = {
            branch: [],
            model: [],
            position: [0, 0, 0],
            name: "",
            folderName: this.resourceId,
            isVisible: false,
            isPlaying: false,
            currentPage: 0,
            isHidden: false,
            hasLeaderLine: false,
            clickedPosition: [0, 0, 0],
            allInfoTagVisibility: true,
        }
    }

    async load(onLoadCallback) {
    }

    async setState(hotSpotData, {patchState}) {
        if (!patchState) {
            const hotSpots = informationAnnotationFeature.hotSpotManager.getAllSpotsById(this.resourceId);
            hotSpots.forEach(hotSpot => informationAnnotationFeature.removeHotSpot(hotSpot.name));
        }

        const allInfoTagVisibility = hotSpotData.length === 0 || hotSpotData.some(state => state.allInfoTagVisibility);
        informationAnnotationFeature.changeHotSpotVisibility(allInfoTagVisibility, informationAnnotationFeature.allInfoTag);

        for (const state of hotSpotData) {
            console.log("Loading information tag: ", state.name);
            let itemArr = Object.values(state);

            // position, delete the position array and insert the individual x, y, z components
            itemArr.splice(2, 1, itemArr[2][0], itemArr[2][1], itemArr[2][2]);
            // clickedPosition, delete the clickedPosition array and insert the individual x, y, z components
            itemArr.splice(12, 1, itemArr[12][0], itemArr[12][1], itemArr[12][2]);

            // branchID, see this.defaultState for reference
            itemArr[0] = itemArr[0] ? itemArr[0].id : '';

            // modelId, see this.defaultState for reference
            itemArr[1] = itemArr[1] ? itemArr[1].id : '';

            await informationAnnotationFeature.addHotSpotAndAttachInformationDataFromServer(itemArr);
        }
    }

    mergeStates(initialState) {
        if (this.states.length === 0) {
            return [];
        }

        let hotSpotData = [];

        this.states.forEach(state => {
            let finalState = {...initialState};
            finalState.branch = state.branch ? state.branch : finalState.branch;
            finalState.model = state.model ? state.model : finalState.model;
            finalState.position = state.position ? state.position : finalState.position;
            finalState.name = state.hotspotName
                ? state.hotspotName
                : (state.name ? state.name : finalState.name); // previously state.name had the state.hotspotName value, so kept it for backward compatibility
            finalState.folderName = state.folderName ? state.folderName : finalState.folderName;
            finalState.isVisible = state.isVisible ? state.isVisible : finalState.isVisible;
            finalState.isPlaying = state.isPlaying ? state.isPlaying : finalState.isPlaying;
            finalState.currentPage = state.currentPage ? state.currentPage : finalState.currentPage;
            finalState.isHidden = state.isHidden ? state.isHidden : finalState.isHidden;
            finalState.hasLeaderLine = state.hasLeaderLine ? state.hasLeaderLine : finalState.hasLeaderLine;
            finalState.clickedPosition = state.clickedPosition ? state.clickedPosition : finalState.clickedPosition;
            finalState.allInfoTagVisibility = state.allInfoTagVisibility ? state.allInfoTagVisibility : finalState.allInfoTagVisibility;
            hotSpotData.push(finalState);
        });

        const uniqueHotspots = [];
        for (let i = hotSpotData.length - 1; i >= 0; i--) {
            if (!uniqueHotspots.some(
                  hotSpot => hotSpot.branch.id === hotSpotData[i].branch.id
                        && hotSpot.position[0] === hotSpotData[i].position[0]
                        && hotSpot.position[1] === hotSpotData[i].position[1]
                        && hotSpot.position[2] === hotSpotData[i].position[2]
            )) {
                uniqueHotspots.push(hotSpotData[i]);
            }
        }

        this.states = [];
        return uniqueHotspots.toReversed();
    }

    getDefaultState() {
        return this.defaultState;
    }
}

export default InformationTag;
